import React from "react";
import "./LoadCard.css"; // Updated styling
import moment from "moment";
import { MdCurrencyRupee } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const LoadDetailsCard = ({ details }) => {
  const extractAddressComponents = (address) => {
    const parts = address.split(",").map((part) => part.trim()); // Split by comma and trim spaces
    const length = parts.length;

    if (length < 3) {
      return { city: "", state: "", pincode: "", country: "" }; // Handle incorrect format
    }

    const country = parts[length - 1]; // Last part is Country
    const statePincode = parts[length - 2].split(" "); // Second last part contains State & Pincode
    const state = statePincode.slice(0, -1).join(" "); // All except last word is State
    const pincode = statePincode[statePincode.length - 1]; // Last word is Pincode
    const city = parts[length - 3]; // Third last part is City

    return { city, state, pincode, country };
  };
  return (
    <div className="load-card">
      <div className="loadFirst">
        <div style={{ marginTop: "10px" }}>
          <svg
            width="10"
            height="67"
            viewBox="0 0 10 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="5.33683"
              cy="5.42777"
              r="4.57291"
              fill="#E57556"
              fillOpacity="0.5"
            />
            <circle cx="5.33679" cy="5.42777" r="3.42968" fill="#E57556" />
            <circle
              cx="5.33683"
              cy="61.446"
              r="4.57291"
              fill="#33C154"
              fillOpacity="0.5"
            />
            <circle cx="5.33679" cy="61.446" r="3.42968" fill="#33C154" />
            <path
              d="M5.33679 10.0007V56.873"
              stroke="#44585F"
              strokeWidth="0.228645"
              strokeDasharray="1.14 1.14"
            />
          </svg>
        </div>
        <div className="loadFirstA">
          <div>
            <p className="city">
              {details?.fromCity.city
                ? details?.fromCity.city
                : extractAddressComponents(details?.fromCity.name).city}
              ,
              {details?.fromCity.state
                ? details?.fromCity.state
                : extractAddressComponents(details?.fromCity.name).state}
            </p>
            <div className="loadFirstA1">
              <p>
                {moment(details.loadingDate)
                  .add(5, "hours")
                  .add(30, "minutes")
                  .format("DD/MM/YYYY  |   HH:mm A")}
              </p>
              {/* <p>|</p>{" "}
              <p>
                {moment(details?.loadingDate)
                  .add(5, "hours")
                  .add(30, "minutes")
                  .format("HH:mm A")}
              </p> */}
            </div>
          </div>
          <div>
            <p className="city">
              {extractAddressComponents(details?.toCity.name).city},{" "}
              {extractAddressComponents(details?.toCity.name).state}
            </p>
            <div className="loadFirstA1">
              <p>
                {" "}
                {moment(details?.deliveryDate)
                  .add(5, "hours")
                  .add(30, "minutes")
                  .format("DD/MM/YYYY  |  HH:mm A")}
              </p>{" "}
              {/* <p>|</p>{" "}
              <p>
                {moment(details?.deliveryDate)
                  .add(5, "hours")
                  .add(30, "minutes")
                  .format("HH:mm A")}
              </p> */}
            </div>
          </div>
        </div>
      </div>
      <div className="loadSecond">
        <p>{details?.distance ? details?.distance : 0} Km</p>
        <svg
          width="110"
          height="14"
          viewBox="0 0 110 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M110 7L67 7"
            stroke="#44585F"
            strokeWidth="0.218997"
            strokeDasharray="1.09 1.09"
          />
          <path
            d="M43 7L-3.57628e-06 7"
            stroke="#44585F"
            strokeWidth="0.218997"
            strokeDasharray="1.09 1.09"
          />
          <path
            d="M60 5.99738C60 9.88423 55 13.2158 55 13.2158C55 13.2158 50 9.88423 50 5.99738C50 4.67199 50.5268 3.40089 51.4645 2.4637C52.4021 1.52651 53.6739 1 55 1C56.3261 1 57.5979 1.52651 58.5355 2.4637C59.4732 3.40089 60 4.67199 60 5.99738Z"
            stroke="#9CA7AC"
            strokeWidth="0.723856"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.9999 7.66313C55.9204 7.66313 56.6666 6.91733 56.6666 5.99734C56.6666 5.07734 55.9204 4.33154 54.9999 4.33154C54.0794 4.33154 53.3333 5.07734 53.3333 5.99734C53.3333 6.91733 54.0794 7.66313 54.9999 7.66313Z"
            stroke="#9CA7AC"
            strokeWidth="0.723856"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p>{details?.duration ? details?.duration : 0} hours</p>
      </div>
      <div className="loadThird">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            marginBottom: "20px",
          }}
        >
          <div>
            <p className="Main_Text">{details?.truckCapacity?.label}</p>
            <p className="Secondary_Text"> Capacity</p>
          </div>
          <div>
            <svg
              width="1"
              height="33"
              viewBox="0 0 1 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.35437 32.8284L0.354367 0.354361"
                stroke="#44585F"
                strokeOpacity="0.5"
                strokeWidth="0.231957"
                strokeDasharray="1.16 1.16"
              />
            </svg>
          </div>
          <div>
            <p className="Main_Text">{details?.vehicleSize?.label}</p>
            <p className="Secondary_Text"> Size</p>
          </div>
          <div>
            <svg
              width="1"
              height="33"
              viewBox="0 0 1 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.35437 32.8284L0.354367 0.354361"
                stroke="#44585F"
                strokeOpacity="0.5"
                strokeWidth="0.231957"
                strokeDasharray="1.16 1.16"
              />
            </svg>
          </div>
          <div>
            <p className="Main_Text">{details?.bodyType?.label}</p>
            <p className="Secondary_Text"> Body Type</p>
          </div>
        </div>
        <div>
          <div
            style={{
              // textAlign: "center",
              padding: "0px 0px 0px 0px",
              margin: "0px 0px 0px -4px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "120px",
              display: "inlineBlock",
              verticalAlign: "middle",
            }}
          >
            <OverlayTrigger
              overlay={
                <Tooltip id={`products-delete-tooltip-${1}`}>
                  <p className="Main_Text">{details?.productType?.label}</p>
                </Tooltip>
              }
            >
              <p className="Main_Text">{details?.productType?.label}</p>
            </OverlayTrigger>
            <p className="Secondary_Text"> Product Type</p>
          </div>
          <div className="loadThird_price">
            <p className="Secondary_Text">Offered Rate*</p>

            <p className="Main_Text">
              <span>
                <MdCurrencyRupee size={18} />
              </span>
              {Number(details.OfferedRate).toLocaleString("en-IN")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadDetailsCard;
